import { get } from '.';

export function GetServices(options = {}) {
	return get<any>("/app/api/services", options);
}
